/**
 * AndroidBackButton — 안드로이드 하드웨어 백버튼 인앱 핸들러 레지스트리
 *
 * Capacitor 'backButton' 네이티브 이벤트는 App.tsx 모듈 스코프에서 1회만 구독한다.
 * 화면 상태(상세 오버레이 등)를 백버튼으로 닫아야 하는 컴포넌트는
 * useAndroidBackHandler 훅으로 핸들러를 등록한다.
 *
 * 핸들러는 LIFO(나중 등록 = 더 위에 떠 있는 UI)로 순회하며, true 를 반환하면
 * 이벤트가 소비된 것으로 보고 기본 동작(두 번 눌러 앱 종료)을 건너뛴다.
 * 아무도 소비하지 않으면 false 를 반환해 기본 동작으로 넘어간다.
 */
export type BackHandler = () => boolean;

export class AndroidBackButton {
  private static handlers: BackHandler[] = [];

  /** 핸들러 등록 — 반환된 함수로 해제. 나중에 등록된 핸들러가 먼저 실행된다(LIFO). */
  static register(handler: BackHandler): () => void {
    this.handlers.push(handler);
    return () => {
      const idx = this.handlers.indexOf(handler);
      if (idx >= 0) this.handlers.splice(idx, 1);
    };
  }

  /** 백버튼 이벤트 처리 — 어떤 핸들러가 소비하면 true (앱 종료 로직 생략) */
  static handleBack(): boolean {
    for (let i = this.handlers.length - 1; i >= 0; i--) {
      if (this.handlers[i]()) return true;
    }
    return false;
  }
}
